import { DataType } from "@sa/rep-common";
import { MultiplicityType } from "@sa/rep-core";
import { MapDataSource } from "./MapDataSource";

export enum MapDimensionType {
  Hierarchy = 0,
  Calendar = 3,
}

export class MapDimension {
  dataSource?: MapDataSource;
  order?: number;
  visible?: boolean;
  multiplicityType?: MultiplicityType;
  dataType?: DataType;
  selectableParent?: boolean;

  constructor(
    public id: number, 
    public name: string, 
    public identifier: string,
    public hierarchy: string,
    public type: MapDimensionType | number
  ) {
    this.order = 0;
  }

  static fromDTO(payload: object) {
    const id = payload['id'];
    const name = payload['name'];
    const identifier = payload['identifier'];
    const hierarchyIdentifier = payload['hierarchyIdentifier'];
    const type = payload['type'];
    const result = new MapDimension(id, name, identifier, hierarchyIdentifier, type);
    result.visible = payload['visible'] === false ? false : true;
    result.order = payload['order'];
    result.selectableParent = Boolean(payload['selectableParent']);
    return result;
  }
}